import {useIntl} from 'react-intl'
import {useRemoveProductFromWishList} from '../../../hooks/use-wish-list'
import {IconButton} from '@chakra-ui/react'
import {BinBGWhiteIcon} from '../../icons'
import React from 'react'
import PropTypes from 'prop-types'
import {useProductTileStyles} from '../context'

/**
 * Remove from wishlist product tile overlay button
 *
 * @param {boolean} isDisabled
 * @param {object} product
 * @param {func} onClick
 */
const RemoveFromWishlistOverlayButton = ({isDisabled, product, onClick}) => {
    const {formatMessage} = useIntl()
    const styles = useProductTileStyles()
    const {mutate: removeFromWishlist, isLoading} = useRemoveProductFromWishList()
    return (
        <IconButton
            {...styles.overlayCta}
            pointerEvents="auto"
            isDisabled={isDisabled || isLoading}
            isLoading={isLoading}
            icon={<BinBGWhiteIcon boxSize={4.5} />}
            onClick={(e) => {
                e?.stopPropagation?.()
                e?.preventDefault?.()
                removeFromWishlist(product.id)
                onClick?.()
            }}
            aria-label={formatMessage({
                id: 'global.remove_product_from_wishlist',
                defaultMessage: 'Remove product from wishlist'
            })}
        />
    )
}

RemoveFromWishlistOverlayButton.propTypes = {
    isDisabled: PropTypes.bool,
    product: PropTypes.object,
    onClick: PropTypes.func
}

export default RemoveFromWishlistOverlayButton
